import React from 'react';
import { Alert, Typography } from '@one-thd/sui-atomic-components';
var AlertBanner = function (_a) {
    var alertMessage = _a.alertMessage, alertTitle = _a.alertTitle, status = _a.status, onClose = _a.onClose;
    return (React.createElement(Alert, { status: status, onClose: onClose, "data-testid": "alert-banner" },
        alertTitle && (React.createElement(Typography, { variant: "body-base", weight: "bold" }, alertTitle)),
        alertMessage));
};
export default AlertBanner;
